import { useTranslation } from 'react-i18next';

const PLACE_QUERY =
  'Hyatt+Regency+Lake+Tahoe+Resort,+111+Country+Club+Drive,+Incline+Village,+NV+89451';

export default function MapsEmbed() {
  const { t } = useTranslation();
  const src = `https://maps.google.com/maps?q=${PLACE_QUERY}&t=&z=14&ie=UTF8&iwloc=&output=embed`;

  return (
    <div className="w-full overflow-hidden rounded-2xl shadow-card aspect-video">
      <iframe
        src={src}
        title={t('details.mapTitle')}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allowFullScreen
        className="w-full h-full border-0"
      />
    </div>
  );
}
